import { SUPPORTED_COUNTRY_POLICY_COPY } from '../content/countryPolicyContent';

const SUPPORTED_COUNTRY_CODES = new Set(
  SUPPORTED_COUNTRY_POLICY_COPY.map((c) => c.code.toUpperCase())
);

export interface CompanyCountryLookup {
  id: string;
  countryCode?: string | null;
}

/** True when the user cannot book leave until an administrator fixes company/country in User Management or Reference Data. */
export function isMissingCompanyForLeave(
  companyId: string | null | undefined,
  companiesById: ReadonlyMap<string, CompanyCountryLookup>
): boolean {
  if (!companyId?.trim()) return true;
  const company = companiesById.get(companyId);
  if (!company) return true;
  const code = (company.countryCode ?? '').trim().toUpperCase();
  return !code || !SUPPORTED_COUNTRY_CODES.has(code);
}
